<template>
	<div class="header-container">
		<div class="header-left">
			<div class="logo">{{ $t('designForm.designerTitle') }}</div>
			<!--			<a href="https://github.com/makunet/maku-form-design" title="GitHub" target="_blank">-->
			<!--				<ma-icon icon="github" color="#666"></ma-icon>-->
			<!--			</a>-->
			<a href="https://gitee.com/makunet/maku-form-design" title="Gitee" target="_blank">
				<ma-icon icon="gitee" color="#666"></ma-icon>
			</a>
		</div>
		<div class="header-right">
			<el-button v-if="$attrs.import" type="primary" text link @click="emits('import')">
				<template #icon>
					<ma-icon icon="import"></ma-icon>
				</template>
				{{ $t('designForm.importJson') }}
			</el-button>
			<el-button v-if="$attrs.preview" type="primary" text link @click="emits('preview')">
				<template #icon>
					<ma-icon icon="preview"></ma-icon>
				</template>
				{{ $t('designForm.preview') }}
			</el-button>
			<el-button v-if="$attrs.clearable" type="primary" text link @click="emits('clearable')">
				<template #icon>
					<ma-icon icon="clearable"></ma-icon>
				</template>
				{{ $t('designForm.clear') }}
			</el-button>
			<el-button v-if="$attrs.generateJson" type="primary" text link @click="emits('generateJson')">
				<template #icon>
					<ma-icon icon="json"></ma-icon>
				</template>
				{{ $t('designForm.generateJson') }}
			</el-button>
			<slot name="button"></slot>
		</div>
	</div>
</template>
<script lang="ts" setup>
const emits = defineEmits(['import', 'preview', 'clearable', 'generateJson'])
</script>

<style lang="scss" scoped>
.header-container {
	display: flex;
}

.header-left {
	flex: 1;
	height: inherit;
	display: flex;
	align-items: center;

	.logo {
		font-size: 16px;
		font-weight: bold;
		color: var(--el-color-primary);
	}

	.ma-icon {
		font-size: 20px;
		display: inline-block;
		vertical-align: middle;
		text-align: center;
	}

	a {
		margin-left: 15px;
	}

	a:hover {
		color: var(--el-color-primary-light-3);
	}
}

.header-right {
	flex: 1;
	height: inherit;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
</style>
